import { render, staticRenderFns } from "./PortalLink.vue?vue&type=template&id=598f4d77&"
import script from "./PortalLink.vue?vue&type=script&lang=js&"
export * from "./PortalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../ceesar.scenario.editor/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports